module.exports = __webpack_public_path__ + "img/zawaroom_h.8d419f80.svg";